<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo :titulo="locale[local].screen.avisos.tituloLabel" />
      <v-divider />

      <template>
        <v-row justify="space-around">
          <v-col cols="12" md="8" lg="10" xl="9">
            <v-switch
              v-model="mostraTodos"
              :label="`Mostrar Todos`"
              @change="changedTodos"
            ></v-switch>
          </v-col>
        </v-row>

        <v-row justify="space-around" v-if="Object.keys(avisoLido).length == 0">
          <v-col cols="12" md="8" lg="10" xl="9">
            <v-skeleton-loader
              :loading="loading"
              transition="scale-transition"
              height="140"
              :types="{ skeleton: 'list-item@3' }"
              type="skeleton"
            >
              <template>
                <v-timeline dense align-top v-if="possuiAvisos">
                  <v-timeline-item
                    v-for="[key, val] of avisosAgrupados"
                    :key="key"
                    small
                  >
                    <div>
                      <h2 :class="`headline mb-4`">
                        {{
                          key.substring(8) +
                          "/" +
                          key.substring(5, 7) +
                          "/" +
                          key.substring(0, 4)
                        }}
                      </h2>
                      <div>
                        <v-card
                          max-height="120"
                          v-for="aviso in val"
                          :key="aviso.sequencia"
                          class="elevation-2 my-4"
                          @click.native="lerAviso(aviso)"
                          :class="{ unread: aviso.situacao == 'N' }"
                        >
                          <v-card-text class="pb-2">
                            <div class="d-flex justify-space-between">
                              <div
                                class="body-1 pt-1 d-inline-block text-truncate"
                                :class="{ unread_text: aviso.situacao == 'N' }"
                                :style="
                                  aviso.situacao == 'N'
                                    ? { 'font-weight': '600' }
                                    : { 'font-weight': '400' }
                                "
                              >
                                {{ aviso.mensagem }}
                              </div>

                              <div class="d-inline-block text-right">
                                <v-tooltip
                                  top
                                  v-if="aviso.sequenciaAnexo.length > 0"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                      <v-icon color="blue lighten-1"
                                        >mdi-paperclip</v-icon
                                      >
                                    </v-btn>
                                  </template>
                                  <span>{{
                                    locale[local].screen.avisos
                                      .possuiAnexosLavel
                                  }}</span>
                                </v-tooltip>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </div>
                    </div>
                  </v-timeline-item>
                </v-timeline>

                <template v-else>
                  <h2>{{ locale[local].screen.avisos.possuiAnexosLavel }}</h2>
                </template>
              </template>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </template>

      <template>
        <v-row justify="space-around">
          <v-col
            cols="12"
            md="8"
            lg="10"
            xl="9"
            v-if="Object.keys(avisoLido).length"
          >
            <v-row justify="space-around">
              <v-col cols="12" md="8" lg="10">
                <v-card class="mx-auto" tile>
                  <v-card-title>
                    {{
                      avisoLido.dtAviso.substring(8) +
                      "/" +
                      avisoLido.dtAviso.substring(5, 7) +
                      "/" +
                      avisoLido.dtAviso.substring(0, 4)
                    }}
                  </v-card-title>
                  <v-card-text style="font-size: 24px">
                    {{ avisoLido.mensagem }}
                  </v-card-text>
                  <v-card-actions v-if="avisoLido.sequenciaAnexo.length > 0">
                    <h3 class="px-2">Anexos :</h3>
                    <v-chip-group active-class="primary white--text">
                      <v-chip
                        v-for="anexo in avisoLido.seqAnexos"
                        :key="anexo"
                        @click="downloadItem(avisoLido, anexo)"
                        >{{ anexo }}</v-chip
                      >
                    </v-chip-group>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="text-center" cols="12">
                <div class="my-2">
                  <v-btn large color="primary" @click="avisoLido = {}"
                    >OK</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Service from "@/components/api/Service";

export default {
  data() {
    return {
      service: new Service(),
      loading: false,
      possuiAvisos: false,
      avisos: [],
      avisosAgrupados: [],
      avisoLido: {},
      mostraTodos: false,
    };
  },
  created() {
    moment.locale("pt-br");
    this.buscarAvisos(false);
  },
  methods: {
    moment: function () {
      return moment();
    },
    async buscarAvisos(tipo) {
      this.loading = true;

      try {
        var resposta = await this.service.buscarAvisos({
          codPessoa: parseInt(localStorage.getItem("codPessoa")),
          todos: tipo
        });

        if (resposta.status === 200) {
          if (resposta.data.retorno) {
            if (resposta.data.retorno[0].estatus === "Erro") {
              throw new Error(resposta.data.retorno[0].msgErro);
            }
          }

          this.avisos = resposta.data.Avisos;
          this.avisosAgrupados = this.groupBy(
            this.avisos,
            (aviso) => aviso.dtAviso
          );

          this.possuiAvisos = this.avisos.length > 0 ? true : false;

          this.loading = false;
        } else {
          throw new Error();
        }
      } catch (e) {
        this.loading = false;
      }
    },
    async lerAviso(aviso) {
      try {
        aviso.situacao = "L";
        this.avisoLido = aviso;
        this.avisoLido.seqAnexos = aviso.sequenciaAnexo.split(",");
        let that = this;
        let extensoes = aviso.extensaoAnexo.split(",");
        let dataAviso = moment(aviso.dtAviso);

        this.avisoLido.extAnexos = extensoes.reduce(function (
          result,
          field,
          index
        ) {
          result[that.avisoLido.seqAnexos[index]] = field;
          return result;
        },
        {});

        var resposta = await this.service.alteraSituacaoAviso({
          codPessoa: parseInt(localStorage.getItem("codPessoa")),
          codEmp: parseInt(aviso.codEmp),
          codEmpregado: parseInt(aviso.codEmpregado),
          dtAviso:
            dataAviso.format("DD") +
            "-" +
            dataAviso.format("MM") +
            "-" +
            dataAviso.format("YYYY"),
          sequencia: parseInt(aviso.sequencia),
        });

        this.$root.$emit("atualizarQuantidadeAvisos");

        if (resposta.status != 200) {
          throw new Error();
        }
      } catch (e) {
        console.log(e);
      }
    },

    downloadItem(aviso, seqAnexo) {
      let dataAviso = moment(aviso.dtAviso);
      let dataAvisoFormatado = dataAviso.format("YYYYMMDD");

      var url = this.service.buscaAnexo(
        aviso.codEmp,
        aviso.codEmpregado,
        aviso.codMensagem,
        aviso.sequencia,
        dataAvisoFormatado,
        seqAnexo
      );

      axios
        .get(url, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          let blob = new Blob([response.data]),
            url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          let ext = this.avisoLido.extAnexos
            ? this.avisoLido.extAnexos[seqAnexo] ?? "jpg"
            : "jpg";
          link.setAttribute("download", `anexo${seqAnexo}.${ext}`);
          document.body.appendChild(link);
          link.click();
        });
    },
    groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
          map.set(key, [item]);
        } else {
          collection.push(item);
        }
      });
      return map;
    },
    changedTodos(valor){
      if (valor === true){
        this.buscarAvisos(true)
      } else
      {
        this.buscarAvisos(false)
      }
    }
  },
};
</script>

<style scoped>
.unread {
  background-color: lightgrey;
}

.unread_text {
  font-weight: bold;
}
</style>
